import api from './api';

const logsService = {
  getLogs: async (params = {}) => {
    const response = await api.get('/logs', { params });
    return response.data;
  },

  getLogById: async (id) => {
    const response = await api.get(`/logs/${id}`);
    return response.data;
  },

  createLog: async (logData) => {
    const response = await api.post('/logs', logData);
    return response.data;
  },

  updateLog: async (id, logData) => {
    const response = await api.put(`/logs/${id}`, logData);
    return response.data;
  },

  submitLog: async (id) => {
    const response = await api.post(`/logs/${id}/submit`);
    return response.data;
  },

  deleteLog: async (id) => {
    const response = await api.delete(`/logs/${id}`);
    return response.data;
  },
};

export default logsService;
